import React from 'react';

import LinkList from '../ui/link-list/LinkList';
import HeaderLink from '../link/Link';
// eslint-disable-next-line
import SkipLink from '../skip-link/SkipLink';

import styles from './link-list.scss';

const TopLinks = ({ links }) => (
  <LinkList links={links} Item={HeaderLink} className={styles.links} />
);

const SkipLinks = ({ links }) => (
  <LinkList links={links} Item={SkipLink} className={styles.skip} />
);

export { TopLinks, SkipLinks };
